import { call, put, takeLatest } from 'redux-saga/effects';
import { getSelects, getDatas, deleteDatas } from '../../../services/setting/mailMagazineList.service';
import {
  ACTION_TYPE,
  actInitMailMagazineListSuccess,
  actCallApiMailMagazineListSuccess,
  actCallApiDeleteMailMagazineSuccess,
} from './action';
import { actCallApiServerError } from '../../common/common/action';

/**
 * 初期表示
 *
 */
function* callApiInitMailMagazineList() {
  try {
    const selects = yield call(getSelects, {});
    yield put(actInitMailMagazineListSuccess(selects));
  } catch (error) {
    yield put(actCallApiServerError(error));
  }
}

/**
 * 検索処理
 *
 * @param
 */
function* callApiMailMagazineList({ searchCondition }) {
  try {
    const datas = yield call(getDatas, searchCondition);
    yield put(actCallApiMailMagazineListSuccess(datas));
  } catch (error) {
    yield put(actCallApiServerError(error));
  }
}

/**
 * 削除処理
 *
 * @param
 */
function* callApiDeleteMailMagazine({ ids }) {
  try {
    const datas = yield call(deleteDatas, ids);
    yield put(actCallApiDeleteMailMagazineSuccess(datas));
  } catch (error) {
    yield put(actCallApiServerError(error));
  }
}

/**
 * Export default root saga
 * @returns {IterableIterator<boolean>}
 */
export default function* watchCallMailMagazineList() {
  yield takeLatest(ACTION_TYPE.CALL_API_INIT_MAIL_MAGAZINE_LIST, callApiInitMailMagazineList);
  yield takeLatest(ACTION_TYPE.CALL_API_MAIL_MAGAZINE_LIST, callApiMailMagazineList);
  yield takeLatest(ACTION_TYPE.CALL_API_DELETE_MAIL_MAGAZINE, callApiDeleteMailMagazine);
}
